import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import ExamArchServices from '../../services/examarchServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('examarch/list', async (query, thunkAPI) => {
  try {
    const response = await ExamArchServices.getList(query);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListArchive = createAsyncThunk('examarch/archive', async (query, thunkAPI) => {
  try {
    const response = await ExamArchServices.getListArchive(query);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('examarch/create', async (data, thunkAPI) => {
  try {
    const response = await ExamArchServices.create(data);

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('examarch/read', async (id, thunkAPI) => {
  try {
    const response = await ExamArchServices.read(id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateData = createAsyncThunk('examarch/update', async (data, thunkAPI) => {
  try {
    const response = await ExamArchServices.update(data.id, data);

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('examarch/delete', async (id, thunkAPI) => {
  try {
    const response = await ExamArchServices.del(id);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getHistory = createAsyncThunk('examarch/history', async (id, thunkAPI) => {
  try {
    const response = await ExamArchServices.getHistory(id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getPreview = createAsyncThunk('examarch/preview', async (id, thunkAPI) => {
  try {
    const response = await ExamArchServices.getPreview(id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getSession = createAsyncThunk('examarch/getSession', async ({ id, sessionId }, thunkAPI) => {
  try {
    const response = await ExamArchServices.getSession(id, sessionId);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const sessionScore = createAsyncThunk('examarch/sessionScore', async ({ id, sessionId }, thunkAPI) => {
  try {
    const response = await ExamArchServices.sessionScore(id, sessionId);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const storeQuestionScore = createAsyncThunk('examarch/storeQuestionScore', async ({ id, sessionId, questionId, data }, thunkAPI) => {
  try {
    const response = await ExamArchServices.storeQuestionScore(id, sessionId, questionId, data);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const changeStatus = createAsyncThunk('examarch/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await ExamArchServices.changeStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getQuestionList = createAsyncThunk(
  'examarch/getQuestionList',
  async ({ id, page, perPage, sort, orderBy, search }, thunkAPI) => {
    try {
      const response = await ExamArchServices.getQuestionList(id, { page, perPage, sort, orderBy, search });
      return response.data;
    } catch (error) {
      if (error.response.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const storeQuestion = createAsyncThunk('examarch/storeQuestion', async ({ id, data }, thunkAPI) => {
  try {
    const response = await ExamArchServices.storeQuestion(id, data);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getQuestion = createAsyncThunk('examarch/getQuestion', async ({ id, questionId }, thunkAPI) => {
  try {
    const response = await ExamArchServices.getQuestion(id, questionId);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateQuestion = createAsyncThunk('examarch/updateQuestion', async ({ id, questionId, data }, thunkAPI) => {
  try {
    const response = await ExamArchServices.updateQuestion(id, questionId, data);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const destroyQuestion = createAsyncThunk('examarch/destroyQuestion', async ({ id, questionId }, thunkAPI) => {
  try {
    const response = await ExamArchServices.destroyQuestion(id, questionId);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getTags = createAsyncThunk('examarch/getTags', async (_, thunkAPI) => {
  try {
    const response = await ExamArchServices.getTags();
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const addStudent = createAsyncThunk('examarch/addStudent', async ({ id, data }, thunkAPI) => {
  try {
    const response = await ExamArchServices.addStudent(id, data);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});
export const removeStudent = createAsyncThunk('examarch/removeStudent', async ({ id, data }, thunkAPI) => {
  try {
    const response = await ExamArchServices.removeStudent(id, data);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getRatings = createAsyncThunk('examarch/getRatings', async ({ id, page, perPage, sort, orderBy }, thunkAPI) => {
  try {
    const response = await ExamArchServices.getRatings(id, { page, perPage, sort, orderBy });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

const initialState = {
  isLoading: false,
  isStoreLoading: false,
  list: [],
  data: null,
  ratings: null,
  questionList: null,
  questionPreview: [],
  question: null,
  group: [],
  answer: [],
  sessionList: [],
  session: null,
  tag: [],
  error: []
};

const examarchSlice = createSlice({
  name: 'examarch',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
        state.error = [];
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors?.length > 0 ? action.payload.errors : [];
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
        state.error = [];
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
        state.error = [];
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors?.length > 0 ? action.payload.errors : [];
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getHistory.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data;
        state.group = action.payload?.session;
      }),
      builder.addCase(getHistory.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getPreview.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getPreview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.questionPreview = action.payload.question;
      }),
      builder.addCase(getPreview.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getSession.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getSession.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data;
        state.questionList = action.payload?.question;
        state.session = action.payload?.session;
      }),
      builder.addCase(getSession.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(sessionScore.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(sessionScore.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(sessionScore.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(storeQuestionScore.pending, (state) => {
        state.isStoreLoading = true;
      }),
      builder.addCase(storeQuestionScore.fulfilled, (state) => {
        state.isStoreLoading = false;
      }),
      builder.addCase(storeQuestionScore.rejected, (state) => {
        state.isStoreLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getQuestionList.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getQuestionList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.exam;
        state.questionList = action.payload?.question;
      }),
      builder.addCase(getQuestionList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(storeQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(storeQuestion.fulfilled, (state, action) => {
        state.isLoading = false;
        state.question = action.payload;
      }),
      builder.addCase(storeQuestion.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors?.length > 0 ? action.payload.errors : [];
      }),
      builder.addCase(getQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getQuestion.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data;
        state.question = action.payload?.question;
      }),
      builder.addCase(getQuestion.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateQuestion.fulfilled, (state, action) => {
        state.isLoading = false;
        state.question = action.payload;
      }),
      builder.addCase(updateQuestion.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors?.length > 0 ? action.payload.errors : [];
      }),
      builder.addCase(destroyQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(destroyQuestion.fulfilled, (state) => {
        state.isLoading = false;
        state.data = null;
      }),
      builder.addCase(destroyQuestion.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getTags.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getTags.fulfilled, (state, action) => {
        state.isLoading = false;
        state.tag = action.payload;
      }),
      builder.addCase(getTags.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addStudent.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(addStudent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(addStudent.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(removeStudent.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(removeStudent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(removeStudent.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getRatings.pending, (state) => {
        state.isLoading = true;
        state.ratings = null;
      }),
      builder.addCase(getRatings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ratings = action.payload;
      }),
      builder.addCase(getRatings.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = examarchSlice;
export default reducer;
